import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';
import { Col, Row } from 'react-bootstrap';
import { Button } from 'primereact/button';

const TeacherHistoryPresentAbsentView = ({ schoolClassId, courseId, onChange, onClose }) => {
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
      setLoading(true);
      var params = {login:util.getTrustedUser(), schoolClassId:schoolClassId, courseId:courseId};
      var url = config.Server+`/school/teacher/school-class/present-absent/get`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response;
                  console.log("p a resopnse is> ", response);
                  var n = {...response.data};
                  for(var i=0;i<n.students.length;i++){
                    n.students[i]["timesVisible"] = false;
                  }
                  setItem(n);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
    }, []);

    const mainDialogFooter = function(){
        return (
            <Row className="justify-content-md-center" style={{ direction: "ltr", textAlign:"right" }}>
                <Col style={{textAlign:"rigth"}}>
                    <Button label="انصراف" icon="pi pi-times" outlined onClick={()=>onClose()} iconPos="right" />
                </Col>
            </Row>
        )
    }
    const showStudentTimes = function(row, index){
        var n = {...item};
        n.students[index].timesVisible = !n.students[index].timesVisible;
        setItem(n);
    }

    return (
        <>
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="مشاهده تاریخجه حضور و غیاب" modal className="p-fluid" footer={() => mainDialogFooter()} onHide={() => onClose()}>
            {
                loading?
                <>
                    loding...
                    <br/>
                    <Skeleton />
                </>
                :
                <>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <tbody>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{item.schoolClass.name}</td>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{item.course.name}</td>
                            </tr>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr style={{height:"80px"}}>
                                <th style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>#</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>نام و نام خانوادگی</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>کد ملی</th>
                                <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"normal", fontSize:"8pt", padding:"5px", borderBottom:"1px solid #d0d0d0", position:"relative"}}>
                                    <div style={{transform:"rotate(270deg)", position:"absolute", top:"15px", left:"-5px", width:"80px", height:"35px", textAlign:"left"}}>موجه</div>                                    
                                </th>
                                <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"normal", fontSize:"8pt", padding:"5px", borderBottom:"1px solid #d0d0d0", position:"relative"}}>
                                    <div style={{transform:"rotate(270deg)", position:"absolute", top:"15px", left:"-5px", width:"80px", height:"35px", textAlign:"left"}}>غیر موجه</div>                                    
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                item.students.map((row, index)=>{
                                    return(
                                    <>
                                    <tr style={{cursor:"pointer"}} onClick={()=>showStudentTimes(row, index)}>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.firstname + " " + row.student.lastname}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.nationalId}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0", color:"rgba(20, 151, 20, 1)"}}>{row.leagalAbsent}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0", color:"#F00"}}>{row.unleagalAbsent}</td>
                                    </tr>
                                    {
                                        row.timesVisible?
                                        <tr>
                                            <td colSpan={5}>
                                                <table style={{margin:"3px", width:"calc(100% - 6px"}}>
                                                    <tbody>
                                                        <tr style={{backgroundColor:"#555", color:"#fff"}}>
                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px"}}>تاریخ</td>
                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"center", padding:"3px"}}>زنگ</td>
                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"center", padding:"3px"}}>وضعیت</td>
                                                        </tr>
                                                        {
                                                            row.times.length == 0?
                                                                <tr>
                                                                    <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px"}} colSpan={3}>
                                                                        هیچ غیبتی ثبت نشده است
                                                                    </td>
                                                                </tr>
                                                            :<></>
                                                        }
                                                        {
                                                            row.times.map((n, nInd)=>{
                                                                return(
                                                                    <tr>
                                                                        <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px"}}>{util.SeperateDate(n.date)}</td>
                                                                        <td style={{border:"1px solid #b0b0b0", textAlign:"right", padding:"3px"}}>{util.getTimeIndexName(n.timeIndex)}</td>
                                                                        {
                                                                            n.isLeagal?
                                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"center", padding:"3px", color:"rgba(20, 151, 20, 1)"}}>موجه</td>
                                                                            :
                                                                            <td style={{border:"1px solid #b0b0b0", textAlign:"center", padding:"3px", color:"#F00"}}>غیر موجه</td>
                                                                        }
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        :<></>

                                    }
                                    </>
                                    )
                                })
                            }
                            <tr><td colSpan={5}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                </>
            }

        </Dialog>
        
        <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
        </>
    )
};

export default TeacherHistoryPresentAbsentView;